/**
 * Guests join a lesson by its link, with a name and no account: the page
 * "Join Ryan's lesson", a guest tile named by that name, three tiles in the
 * room. It needs the wrapper to carry three peers (mesh on room-data-channel,
 * Thomas's), so it is off until that ships: the Invite sheet says "Invites
 * open soon" and the invite link goes the signed-in way. VITE_GUEST_JOIN=true
 * turns it on for a build.
 */
export const GUEST_JOIN = import.meta.env.VITE_GUEST_JOIN === 'true';
